import React from 'react';

export const UnorderedList: React.FC<React.HTMLAttributes<HTMLUListElement>> = props => {
    return (
        <ul
            css={{
                margin: 0,
                padding: 0,
            }}
            {...props}
        />
    );
};
